import moment from 'moment';

const projectStrings = require('../locales/project/de.json');

moment.locale('de');

export const getLocalizedProjectStrings = project => {
  const extraInfo = {};
  const dateFormat = 'dddd, DD. MMMM YYYY';
  extraInfo.startDate = moment(project.start).format(dateFormat);

  if (typeof project.end !== 'undefined' && project.end !== null) {
    extraInfo.endDate = moment(project.end).format(dateFormat);
  }

  extraInfo.status = projectStrings[`status_${project.status}`];

  return extraInfo;
};

export default getLocalizedProjectStrings;



// WEBPACK FOOTER //
// ./src/models/Project.js